module.exports = __webpack_public_path__ + "static/media/QuantumIon.4e8a7450.png";